import { useMemo } from 'react';
import { useStoreActions } from "../../../contexts";
import { useQueryState } from "../useQueryState";
import { QueryKeys } from "../queryKeys";
const FALLBACK_SUGGESTIONS = ['Make it more sales-oriented...', 'Simplify the language...', 'Highlight what makes it unique...'];
export const usePromptSuggestions = () => {
  const {
    api
  } = useStoreActions();
  const {
    data: suggestionsResponse
  } = useQueryState({
    queryKey: [QueryKeys.PromptSuggestions],
    queryFn: async () => api.service.getPromptSuggestions(),
    refreshOnHookMount: true
  });
  const suggestions = useMemo(() => {
    if (suggestionsResponse !== null && suggestionsResponse !== void 0 && suggestionsResponse.suggestions && suggestionsResponse.suggestions.length > 0) {
      return suggestionsResponse.suggestions.map(suggestion => suggestion.endsWith('...') ? suggestion : "".concat(suggestion, "..."));
    }
    return FALLBACK_SUGGESTIONS;
  }, [suggestionsResponse]);
  return {
    suggestions
  };
};